// ============================================================
// Incomes API Layer
// ============================================================

import client from './axios';

export const incomesApi = {
  // ── Income Categories ──────────────────────────────────────
  /**
   * Get all income categories
   * GET /incomes/categories?school_id=UUID&include_inactive=false
   */
  getCategories: async (schoolId, includeInactive = false) => {
    const response = await client.get('/incomes/categories', {
      params: { school_id: schoolId, include_inactive: includeInactive },
    });
    return response.data;
  },

  /**
   * Create new income category
   * POST /incomes/categories?school_id=UUID
   * Body: { name: string }
   */
  createCategory: async (schoolId, payload) => {
    const response = await client.post('/incomes/categories', payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Update income category
   * PUT /incomes/categories/{id}?school_id=UUID
   * Body: { name: string, is_active: boolean }
   */
  updateCategory: async (schoolId, id, payload) => {
    const response = await client.put(`/incomes/categories/${id}`, payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Delete income category
   * DELETE /incomes/categories/{id}?school_id=UUID
   */
  deleteCategory: async (schoolId, id) => {
    const response = await client.delete(`/incomes/categories/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  // ── Incomes ────────────────────────────────────────────────
  /**
   * Get list of incomes with optional filtering
   * GET /incomes?school_id=UUID&start_date=YYYY-MM-DD&end_date=YYYY-MM-DD&category_id=UUID
   */
  getIncomes: async (schoolId, params = {}) => {
    const cleanParams = { school_id: schoolId };
    if (params.start_date) cleanParams.start_date = params.start_date;
    if (params.end_date) cleanParams.end_date = params.end_date;
    if (params.category_id && params.category_id !== 'ALL') cleanParams.category_id = params.category_id;

    const response = await client.get('/incomes', { params: cleanParams });
    return response.data;
  },

  /**
   * Get single income by ID
   * GET /incomes/{id}?school_id=UUID
   */
  getIncomeById: async (schoolId, id) => {
    const response = await client.get(`/incomes/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Create new income record
   * POST /incomes?school_id=UUID
   * Body: { income_date, category_id, amount, description, receipt_url }
   */
  createIncome: async (schoolId, payload) => {
    const response = await client.post('/incomes', payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Update existing income record
   * PUT /incomes/{id}?school_id=UUID
   * Body: { income_date, category_id, amount, description, receipt_url }
   */
  updateIncome: async (schoolId, id, payload) => {
    const response = await client.put(`/incomes/${id}`, payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Delete income record
   * DELETE /incomes/{id}?school_id=UUID
   */
  deleteIncome: async (schoolId, id) => {
    const response = await client.delete(`/incomes/${id}`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  /**
   * Get total income summary
   * GET /incomes/summary/total?school_id=UUID&start_date=YYYY-MM-DD&end_date=YYYY-MM-DD
   */
  getSummaryTotal: async (schoolId, params = {}) => {
    const cleanParams = { school_id: schoolId };
    if (params.start_date) cleanParams.start_date = params.start_date;
    if (params.end_date) cleanParams.end_date = params.end_date;

    const response = await client.get('/incomes/summary/total', { params: cleanParams });
    return response.data;
  },
};
